export enum CONCILIATION_STATUS {
	INVALID = -1,
	NOT_STARTED = 0,
	VALID = 1,
	INCORRECT_STATUS = 2,
	NOT_FOUND_ISOLVE = 3,
	NOT_FOUND_BANK = 4,
	DISPUTED_VALUE = 5,
	VALID_WITH_AUTOMATIC_CORRECTION = 6,
	CONTESTED = 7,
	NOT_PAYABLE = 8,
	VALID_WITHOUT_DOCUMENT = 9,
	VALIDATED_MANUALLY = 10,
}

/**
 * Get status conciliation description
 * @returns string
 */
export function getStatusDescription(situationId: number): string {
	switch (situationId) {
		case CONCILIATION_STATUS.INVALID:
			return 'Inválido'
		case CONCILIATION_STATUS.NOT_STARTED:
			return 'Conciliação não iniciada'
		case CONCILIATION_STATUS.INCORRECT_STATUS:
			return 'Status incorreto'
		case CONCILIATION_STATUS.NOT_FOUND_ISOLVE:
			return 'Não encontrado isolve'
		case CONCILIATION_STATUS.NOT_FOUND_BANK:
			return 'Não encontrado banco'
		case CONCILIATION_STATUS.DISPUTED_VALUE:
			return 'Valor em disputa'
		case CONCILIATION_STATUS.VALID:
			return 'Validada'
		case CONCILIATION_STATUS.VALID_WITH_AUTOMATIC_CORRECTION:
			return 'Validada com alterações automáticas'
		case CONCILIATION_STATUS.CONTESTED:
			return 'Contestado'
		case CONCILIATION_STATUS.NOT_PAYABLE:
			return 'Não passível de pagamento'
		case CONCILIATION_STATUS.VALIDATED_MANUALLY:
			return 'Validada manualmente'

		default:
			return 'Situação não mapeada'
	}
}

export function getModifiedFieldValue(modifiedFields: string | null, fieldSearch: string) {
	if (!modifiedFields) return ''

	const jsonObject = JSON.parse(modifiedFields)

	if (fieldSearch in jsonObject) return jsonObject[fieldSearch]

	return ''
}
